import * as React from 'react';
import { FC } from 'react';
import { moneyStr } from 'app/helpers/money';
import { Results } from './types';
import locales from './locales';

const PlayerResults: FC<{ results: Results }> = ({ results }) => {
  const l = locales();

  return (
    <div className="tournament_results t-results" aria-labelledby="results">
      <div className="t-results_top">
        <div className="t-results_icon" />
        <h2 id="results" className="t-results_win">
          {l.summary}
        </h2>
      </div>
      <div className="t-results_info">
        <div className="t-results_text">
          {l.freespins}:&nbsp;<span className="t-results_text__red">{results.freespins}</span>
        </div>
        <div className="t-results_text">
          {l.money}:&nbsp;
          <span className="t-results_text__red">{moneyStr(results.money.amount, results.money.currency)}</span>
        </div>
      </div>
    </div>
  );
};

export default PlayerResults;
